import React from 'react';
import Entry from './entry';
import './entry.scss';

const EntryCreateAccount = () => {

  return (
    <div className="entry-create-account">
      <Entry option="create-account"/>
    </div>
  )
};

export default EntryCreateAccount;